"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/views/distribution/alliance/promoter/index.vue"));
var _index2 = _interopRequireDefault(require("@/views/distribution/alliance/promoter-apply/index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DistributionPromoterCenter',
  components: {
    PromoterList: _index.default,
    PromoterApply: _index2.default
  },
  data: function data() {
    return {
      activeTab: 'list'
    };
  }
};